<button id="promote" type="button" 
[@addRemove]="!isPromoted ? 'add' : 'remove'"
[class.btn-danger]="isPromoted" 
[class.btn-primary]="!isPromoted" 
class="btn" (click)="promote()"><i *ngIf="isPromoted" class="fa-solid fa-star"></i><i *ngIf="!isPromoted" class="fa-regular fa-star"></i></button>